<template>
    <div class="d-flex px-0 justify-end" >	
        <v-menu
            v-if="!$vuetify.breakpoint.xsOnly"
            v-model="showDropdownMenu"
            min-width="150"
            attach="#room-menu-activator-btn"
            rounded
            content-class="sub-list mt-8"
        >
            <v-list-item-group
                v-model="currentRoomIndex"
                active-class="active"
            >
                <Rooms
                    v-if="data.configurationOptions"
                    :rooms="data.configurationOptions"
                    @select-room="selectRoom"
                />
            </v-list-item-group>		
        </v-menu>
        <v-dialog
            v-else
            id="room-items-dialog"
            v-model="showPopupMenu"
            content-class="bottom-room-dialog"
            transition="dialog-bottom-transition"
        >
            <v-card rounded  class="pt-1" >
                <v-toolbar height="auto" flat class="pl-4 mobile-header d-flex">
                    <v-btn
                        icon 
                        color="black"
                        height="auto"
                        width="auto"
                        @click="showPopupMenu = false"
                    >
                        <v-icon black>
                            mdi-close
                        </v-icon>
                    </v-btn>
                    <v-toolbar-title class="justify-space-between">
                        {{ $t('sidebar.rooms') }}
                    </v-toolbar-title> 
                </v-toolbar>  
                <v-list-item-group
                    v-model="currentRoomIndex"
                    active-class="active"
                >
                    <Rooms
                        v-if="data.configurationOptions"
                        :rooms="data.configurationOptions"
                        @select-room="selectRoom"
                    />
                </v-list-item-group>	
            </v-card>
        </v-dialog>
        <v-btn 
            id="room-menu-activator-btn"
            text
            class="text-none pr-0"
            @click="toggleMenu()"
        >   
            <v-icon 
                class="room-icon icon"
                :class="{ 'mr-2': !$vuetify.breakpoint.xs }"
            >
                icon-living-room
            </v-icon>
            <span v-if="!$vuetify.breakpoint.xs">
                {{ $t('sidebar.rooms') }}
            </span>
            <v-btn icon>
                <v-icon
                    class="mdi hotspot-btn"
                >
                    {{ showDropdownMenu || showPopupMenu ?  'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
            </v-btn>
        </v-btn>
    </div>
</template>

<script>
    import {mapGetters } from 'vuex';
    import { EventBus } from '@/event-bus';
    import Rooms from '@/layout/alternative/configurableTour/components/Rooms.vue';
    export default {
        name: "ConfigurableTourHeader",
        components: {
            Rooms
        },
        props: [ "data",],
        data() {
            return{
                currentRoomIndex: 0,
                isLoadingScene: false,
                showDropdownMenu: false,
                showPopupMenu: false,
            }
        },
        computed:{
            ...mapGetters([
                'isIframe',
                'isLocalstorageAvailable',
                'isReviewUse'
            ]),
        },
        methods: {
            selectRoom(newRoom) {
                if (newRoom) {
                    if (!this.isLoadingScene) {
                        this.data.configurationOptions.forEach(configuration => configuration.active = false);
                        this.data.configurationOptions.filter(room => room.id === newRoom.id)[0].active = true;
                        this.currentRoomIndex = this.data.configurationOptions.findIndex(configuration => configuration.active);
                    }
                }
            },
            toggleMenu() {
                if (!this.$vuetify.breakpoint.xsOnly)
                    this.showDropdownMenu = !this.showDropdownMenu
                else
                    this.showPopupMenu = !this.showPopupMenu;
            },
        },
        watch: {
            currentRoomIndex() {
                this.isLoadingScene = true;
                EventBus.$emit('loadRoom', this.currentRoomIndex);
                this.isLoadingScene = false;

            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/layout/alternative/configurableTour/ConfigurableTourHeader.vue